import * as React from 'react'
import styled from '../styles/styled-components'

interface ICardListErrorProps {
  error: string
  fetchCandidates: () => Promise<any>
}

const Container = styled.div`
  width: 100%;
  text-align: center;
`
const StyledButton = styled.button`
  padding: 10px;
`
const StyledError = styled.div`
  color: red;
  margin: 20px 0;
`

export const CardListError: React.SFC<ICardListErrorProps> = ({ error, fetchCandidates }) => (
  <Container>
    <StyledError>{error}</StyledError>
    <StyledButton onClick={fetchCandidates}>{'Retry'}</StyledButton>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/CardListError.tsx